import axios, { AxiosError } from 'axios';

const apiAdmin = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://prevcenso.com/backend/api',
  timeout: 10000,
});

// Interceptor para adicionar o token de admin ao cabeçalho Authorization
apiAdmin.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem('admin_token');
    if (adminToken) {
      config.headers.Authorization = `Bearer ${adminToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para tratar erros 401 (Unauthorized)
apiAdmin.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_id');
      localStorage.removeItem('admin_token');
      localStorage.removeItem('user_level');
      window.location.href = '/rj/admin-login';
    }
    return Promise.reject(error);
  }
);

export default apiAdmin;